import { render } from "./barcodeList.vue?vue&type=template&id=0f4e05c4&scoped=true"
import script from "./barcodeList.vue?vue&type=script&lang=js"
export * from "./barcodeList.vue?vue&type=script&lang=js"

import "./barcodeList.vue?vue&type=style&index=0&id=0f4e05c4&scoped=true&lang=css"

import exportComponent from "D:\\presta\\dev\\key4access\\key4access.front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4e05c4"]])

export default __exports__